import one from "../assets/projects/graphics/flyer.jpg"
import two from "../assets/projects/graphics/church_media.png"
import three from "../assets/projects/graphics/asta.jpg"
import four from "../assets/projects/graphics/pixel_accessories.png"
import five from "../assets/projects/graphics/samy_4real2.jpg"
import six from "../assets/projects/app/Image_Compressor.png"
import seven from "../assets/projects/app/video_format_converter.jpg"
import eight from "../assets/projects/app/Dollar2Cent_Converter.png"
import nine from "../assets/projects/app/Password_Manager.jpg"
import ten from "../assets/projects/UIUX/construction_website.jpg"
import eleven from "../assets/projects/UIUX/facebook_clone.jpg"
import twelve from "../assets/projects/UIUX/food_app.jpg"


const data = [
    {
        category: "graphics",
        image: one,
        info: "Flyer for Garden City Logistics Company",
        link: "#",
        
    },
    {
        category: "graphics",
        image: two,
        info: "Church Media Team Logo",
        link: "#",
        
    },
    {
        category: "graphics",
        image: three,
        info: "Brand Logo",
        link: "#",
        
    },
    {
        category: "graphics",
        image: four,
        info: "Pixel Accessories Logo",
        link: "#",
        
    },
    {
        category: "graphics",
        image: five,
        info: "Samy4Real Logo",
        link: "#",
        
    },
    {
        category: "app",
        image: six,
        info: "Image Compressor Web App",
        link: "https://github.com/thankgodode/image-compressor",
        
    },
    {
        category: "app",
        image: seven,
        info: "Video Format Converter Desktop App",
        link: "",
        
    },
    {
        category: "app",
        image: eight,
        info: "Dollar to Cent Converter Web App",
        link: "https://github.com/thankgodode/dollars2centsconverter",
        
    },
    {
        category: "app",
        image: nine,
        info: "Password Manager Chrome Extension",
        link: "https://github.com/thankgodode/Password-Manager",
        
    },
    {
        category: "ui/ux",
        image: ten,
        info: "Construction Company Design",
        link: "https://www.figma.com/design/XgwYtVc4mN44q5YqoVSBta/Portfolio-Website-Tutorial?m=auto&fuid=1097302083413551265",
        
    },
    {
        category: "ui/ux",
        image: eleven,
        info: "Facebook Clone",
        link: "https://www.figma.com/design/NfgHaI4C70IdpZtDjERetz/Facebook-Clone?m=auto&fuid=1097302083413551265",
        
    },
    {
        category: "ui/ux",
        image: twelve,
        info: "Food App Design",
        link: "https://www.figma.com/design/nPZpvK4wdHjPOB5ocxw5uA/Food-Cover-Design?m=auto&t=ASw2NS0TTiI7hzlk-6",
        
    },
]

export default data